import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import CheckBox from '@/components/profile/checkBox'
import InputBox from '@/components/profile/inputBox'
import DobCom from '@/components/profile/dobCom'
import { listOfSections } from "@/pages/profile/sections/bssDetails/constants"
import ImageHandler from '@/components/common/imageHandler/imageHandler'
import ImageEditer from '@/components/common/imageHandler/imageEditer'
import UploadImage from "@/assets/icons/upload.png"
import '@/pages/profile/sections/common.css'

export default function Signature(props: any) {
    const { common, profile } = useLocalTranslation();
    const [openFilePopup, setOpenFilePopup] = useState(false)
    const [image, setImage] = useState("")

    useEffect(() => {
        if (props.signature) {
            setImage(props.signature)
        }
    }, [props.signature])


    const initFilePopup = () => {
        setOpenFilePopup(true)
        setTimeout(() => {
            setOpenFilePopup(false)
        }, 100)
    }

    const imageSelected = (imageDataURI: any) => {
        setImage(imageDataURI)
        setImgToParentCom(imageDataURI)
    }

    const setImgToParentCom = (imageDataURI: any) => {
        const eventObj = {
            target: {
                value: imageDataURI
            }
        }
        props.handleInputChange(eventObj, listOfSections.signature.signature)
    }

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <div className='commonCon1'>
                <ul className='list-disc list-inside'>
                    {profile.bssSection.notes.n1.map((n: string, index: number) => (
                        <li key={index}>{n}</li>
                    ))}
                </ul>
            </div>

            <p className='commonH5'>
                {profile.bssSection.notes.n2}
            </p>

            <p className='commonH6'>
                {profile.bssSection.notes.n3}
            </p>

            <p className='commonH5'>
                {profile.fields.signature}
                <span className='text-[#FF2828]'>*</span>
            </p>

            <p className='commonH7'>
                {profile.placeHolders.signature}
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            {image ? (
                <div className='proofImgCon'>
                    <ImageEditer
                        initFilePopup={initFilePopup}
                        ogImage={image}
                        setImgToParentCom={setImgToParentCom}
                    // height={200}
                    // width={330}
                    />
                </div>
            ) : (
                <div className='imagePlaceholder'>
                    <img
                        className='w-[42px]'
                        src={UploadImage} alt='UploadImage' />
                    <p className='p1'>{common.statusText.tapOrClickHereToUploadYourDocument}</p>
                    <button
                        onClick={initFilePopup}
                        className='b1'>
                        {common.statusText.browseFiles}
                    </button>
                </div>
            )}


            <div className='mt-[15px]'>
                <p className='commonH4'>
                    {profile.fields.placeOfSignature}
                    <span className='text-[#FF2828]'>*</span>
                </p>
                <InputBox
                    id={listOfSections.guardianName}
                    onChange={(e: any) => props.handleInputChange(e, listOfSections.signature.placeOfSignature)}
                    value={props.placeOfSignature}
                    placeholder={profile.placeHolders.placeOfSignature}
                />
            </div>

            <div className='mt-[15px]'>
                <p className='commonH4'>
                    {profile.fields.dateOfSignature}
                    <span className='text-[#FF2828]'>*</span>
                </p>
                <DobCom
                    onChange={(e: any) => props.handleInputChange(e, listOfSections.signature.dateOfSignature)}
                    value={props.dateOfSignature}
                />

            </div>

            <ImageHandler
                openFilePopup={openFilePopup}
                imageSelected={imageSelected}
            />

            <div className='commonBtnCon1'>
                {image &&
                    <div className='w-[100%] text-left'>
                        <CheckBox
                            id="bssAcknowledged_id"
                            text={profile.bssSection.notes.n4}
                            checked={props.bssAcknowledged}
                            onChange={(e: any) => props.handleOnCheckBoxChanged(e, "bssAcknowledged")}
                            showAsterisk={true}
                        />

                        <button
                            disabled={props.isSubmitBtnLoading}
                            style={{
                                cursor: props.isSubmitBtnLoading ? 'not-allowed' : 'pointer',
                                backgroundColor: props.isSubmitBtnLoading ? '#9f9f9f' : '#1573FE'
                            }}
                            onClick={() => props.handleSubmit(listOfSections.signature.signature)}
                            className='w-[100%] text-white rounded-[5px] py-[8px] text-[14px] font-medium'>
                            {common.statusText.saveAndContinueBtn}
                        </button>
                    </div>
                }
            </div>
        </div>
    );
}
